const prependSymbol = (val, symbol) => {
  let str = '';
  if (typeof val === 'number' && typeof symbol === 'string') {
    str = symbol + val.toFixed(2);
  }
  return str;
}

const prependCurrency = (val) => {
  return prependSymbol(val, '£')
}

const buildItemId = (post) => {
  let str = "";
  if (post.routerLink) {
    str = pathToItemId(post.routerLink);
  }
  return str;
}

const pathToItemId = (path, prefix) => {
  let str = "";
  if (prefix) {
    str = prefix + '-';
  }
  if (typeof path === 'string') {
    if (path.length > 1) {
      str += path.replace(/^\//, "").replace("/", "--");
    }
  }
  return str;
}

const calcRate = (product) => {
  let rate = 1;
  if (product.price && product.priceGross) {
    rate = Math.ceil(product.priceGross / product.price * 100) / 100;
  }
  return rate;
}

export default {
  filters: {
    currency(val) {
      return prependCurrency(val);
    },
    currencyExclVAT(val) {
      let str = prependCurrency(val);
      if (str.length > 0) {
        str += ' excl. VAT';
      }
      return str;
    },
    itemId(post) {
      return buildItemId(post);
    },
    itemIdSpan(post) {
      return 'os-' + buildItemId(post);
    }
  },
  methods: {
    prependCurrency,
    buildItemId,
    pathToItemId,
    calcRate
  }
}